module.exports = __webpack_public_path__ + "static/media/altaproteina_harinadetrigo(1).e604e345.png";